import {
  CreateActionClassRequest,
  ActionClassGetDto,
  AdvancedQueryColumnFilter,
  AdvancedQueryColumnSort,
  ActionClassSummaryDto,
  UpdateActionClassRequest,
  EmptyResponse,
  Error,
  OptionItemDto,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  Response,
  AdvancedQueryPage,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class ActionClassService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateActionClassRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<ActionClassGetDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/action-classes';

      const configs: IRequestConfig = getConfigs('post', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      actionCodeId?: number;
      /**  */
      levelOfServiceCodeId?: number;
      /**  */
      class?: string;
      /**  */
      page?: number;
      /**  */
      pageSize?: number;
      /**  */
      searchFieldNames?: string[];
      /**  */
      searchSearchText?: string;
      /**  */
      searchExactMatch?: boolean;
      /**  */
      filtered?: AdvancedQueryColumnFilter[];
      /**  */
      sorted?: AdvancedQueryColumnSort[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<AdvancedQueryPage<ActionClassSummaryDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/action-classes';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ActionCodeId: params['actionCodeId'],
        LevelOfServiceCodeId: params['levelOfServiceCodeId'],
        Class: params['class'],
        Page: params['page'],
        PageSize: params['pageSize'],
        'Search.FieldNames': params['searchFieldNames'],
        'Search.SearchText': params['searchSearchText'],
        'Search.ExactMatch': params['searchExactMatch'],
        Filtered: params['filtered'],
        Sorted: params['sorted']
      };

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<ActionClassGetDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/action-classes/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /**  */
      id: number;
      /** requestBody */
      body?: UpdateActionClassRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<ActionClassGetDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/action-classes/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EmptyResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/action-classes/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getPartClassOptions(options: IRequestOptions = {}): Promise<Response<List<OptionItemDto<string>>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/action-classes/part-classes';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}
